<template>
  <div class="maxBox">
    <div class="header">
      <div class="position puid">设备号：{{ puid }}</div>
      <div class="title">单兵操作</div>
      <el-button
        class="button2 position"
        @click="$router.push({ path: '/data' })"
        type="primary"
        >返回指挥大屏</el-button
      >
    </div>
    <div class="content">
      <div class="flvBox">
        <HelloWorld :puid="this.$route.query.puid" />
      </div>
    </div>
    <div class="footer">
      <el-button
        v-if="talkType === 1"
        class="button2"
        @click="starttalk(puid)"
        type="primary"
        >开始对讲
      </el-button>
      <el-button v-else type="danger" @click="stopPlay('talkID', puid)"
        >停止对讲</el-button
      >
    </div>
  </div>
</template>
<script>
import HelloWorld from './login/HelloWorld.vue'
import webcu2plugin from 'webcu2plugin'
export default {
  components: {
    HelloWorld
  },
  data () {
    return {
      talkType: 1,
      puid: '',
      talkID: '',
      callID: '',
      isThrottled: false, // 是否处于节流状态
      callType: 1

    }
  },
  mounted () {
    console.log(this.$route.query)
    this.puid = this.$route.query.puid
  },
  methods: {
    async starttalk (puid) {
      if (this.isThrottled) {
        this.$message.error('正在停止，请稍后再试')
        return
      } // 如果处于节流状态，则直接返回
      this.isThrottled = true // 进入节流状态
      setTimeout(() => {
        this.isThrottled = false // 500毫秒后解除节流状态
      }, 1000)
      console.log('puid', puid)
      this.talkType = 2
      this.$forceUpdate()
      const token = localStorage.getItem('flvToken')
      const params = { puid, token }
      const data = await webcu2plugin.startTalk(params)
      if (!data && !data.playID) return
      this.talkID = data.playID
      console.log(data.playID, '对讲')
      this.$message.success('已启动对讲')
    },
    async stopPlay (type, puid) {
      if (this.isThrottled) {
        this.$message.error('正在对讲中，请稍后再试')
        return
      } // 如果处于节流状态，则直接返回
      this.isThrottled = true // 进入节流状态
      setTimeout(() => {
        this.isThrottled = false // 500毫秒后解除节流状态
      }, 1000)
      if (type === 'callID') {
        this.callType = 1
      } else {
        this.talkType = 1
      }
      this.$forceUpdate()
      const token = localStorage.getItem('flvToken')
      let playID = ''
      if (type === 'callID') {
        playID = String(this.callID)
      } else {
        playID = String(this.talkID)
      }
      const params = { id: playID, token: token }
      const data = await webcu2plugin.stoptStream(params)
      console.log(data.msg, '_______________________________')
      if (data.msg === 'OK') {
        this.$message.success('已停止')
      } else {
        this.$message.success('未停止')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.maxBox {
  width: 100vw;
  height: 100vh;
  background-color: #102248;
  .header {
    width: 100%;
    padding: 0 30px;
    height: 10%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .puid {
      font-size: 20px;
      color: #fff;
    }
    .position {
      width: 200px;
    }
    .title {
      font-size: 30px;
      font-weight: 600;
      color: #fff;
    }
  }
  .content {
    width: 100%;
    height: 80%;
    display: flex;
    justify-content: center;
    align-items: center;
    .flvBox {
      width: 80%;
      height: 100%;
    }
  }
  .footer {
    width: 100%;
    height: 10%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/IndividualVideo.vue